import React from "react";
import { Button } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import {useFileDownloader} from "../../hooks";
import { IconExport } from "../icons";
import {useDispatch, useSelector} from "react-redux";
import {getButtonProcessingClass, isButtonProcessing} from "../../utils/common-utils";
import {clearButtonProcessing, setButtonProcessing} from "../../store/actions";

const ButtonExport = (props) => {
  const dispatch = useDispatch();
  const {buttonColor, iconColor, description, borderColor, descriptionTextColor, titleTextColor, apiUrl, ...rest} = props;
  const buttonProcessingState = useSelector((state) => state.button_processing);
  const isProcessing = isButtonProcessing(buttonProcessingState, props)
  const processingClass = getButtonProcessingClass(isProcessing);
  const { downloadFileFromPath } = useFileDownloader();
  const handleDownload = () => {
    dispatch(setButtonProcessing(props?.id));
    downloadFileFromPath(apiUrl).finally(() => {
      dispatch(clearButtonProcessing(props?.id))
    });
  };
  return (
    <>
      <Button
        type="button"
        theme={tenkenTheme.button}
        color={buttonColor}
        className={`xl:w-[380px] lg:w-[340px] w-[300px] ${processingClass}`}
        isProcessing={isProcessing}
        onClick={() => handleDownload()}
        {...rest}
      >
        <div className="export-btn__frame">
          <div className="xl:min-w-[225px] min-w-[200px] xl:p-[10px] p-[8px] pl-[8px]">
            <div className={`${descriptionTextColor} export-text__description`}>
              <p>{description}</p>
            </div>
            <h4 className={`${titleTextColor} export-text__title`}>
              ダウンロード
            </h4>
          </div>
          <IconExport color={iconColor} borderColor={borderColor} />
        </div>
      </Button>
    </>
  );
};

export default ButtonExport;
